import React from 'react';

export default function SubscriberConfirmed() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <img
          src="/HRO-Logo-transparent-white-logo.png"
          alt="Horse Racing Oracle"
          className="mx-auto h-12 w-auto"
        />
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10 text-center">
          <div className="mb-6">
            <div className="flex justify-center">
              <div className="rounded-full bg-green-100 p-3">
                <svg className="h-12 w-12 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
            </div>
            <h2 className="mt-6 text-3xl font-extrabold text-gray-900">Welcome to Horse Racing Oracle!</h2>
            <p className="mt-4 text-lg text-gray-600">Your VIP Monthly Membership begins today.</p>
          </div>

          <div className="mt-6">
            <a
              href="https://app.horseracingoracle.com/register"
              className="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-lg font-medium text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
            >
              Click Here to Register Your Account
            </a>
          </div>
        </div>
      </div>
    </div>
  );
} 